import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from './constants/colors';
import { errorTypes } from '../data/error.redux';
import mediaQueries from './constants/mediaQueries';

export const BANNER_HEIGHT_DESKTOP = '50px';
export const BANNER_HEIGHT_MOBILE = '76px';

const ErrorBanner = styled.div`
  align-items: center;
  background: ${colors.opalFlame};
  color: ${colors.white};
  display: flex;
  justify-content: center;
  margin-bottom: auto;
  padding: 14px;
  font-size: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;

  a {
    color: ${colors.white};
  }

  ${mediaQueries.desktop`
    height: ${BANNER_HEIGHT_DESKTOP};
  `}

  ${mediaQueries.mobile`
    height: ${BANNER_HEIGHT_MOBILE};
  `}

  @media screen and (min-width: 1024px) {
    margin-bottom: 0;
    position: absolute;
    top: 0;
  }

  &.-error {
    background: ${colors.opalFlame};
  }
`;

const emailUnavailableError = (
  <ErrorBanner>
    <div>
      An account with this email already exists. Please <a href="https://bench.co/login">log in</a>{' '}
      using this email.
    </div>
  </ErrorBanner>
);

const serverError = (
  <ErrorBanner>
    <div>Something went wrong, please try again or refresh the page.</div>
  </ErrorBanner>
);

const getError = (
  <ErrorBanner>
    <div>
      Something went wrong, try refreshing the page, or skip to the next step and we’ll reach out to
      help you finish setting things up.
    </div>
  </ErrorBanner>
);

const genericError = message => <ErrorBanner>{message}</ErrorBanner>;

const customErrorTypes = {
  [errorTypes.EMAIL_UNAVAILABLE]: emailUnavailableError,
  [errorTypes.POST_ERROR]: serverError,
  [errorTypes.GET_ERROR]: getError,
};

const Error = ({ type, message }) => {
  return customErrorTypes[type] || genericError(message);
};

Error.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
};

Error.defaultProps = {
  message: 'An error occurred. Please try again',
  type: 'generic',
};

export default Error;
